import React, { useRef, useEffect } from "react";
import classes from "./MenuButton.module.css";
import { gsap } from "gsap";

const MenuButton = (props) => {
  const barOneRef = useRef(null);
  const barTwoRef = useRef(null);
  const barThreeRef = useRef(null);

  useEffect(() => {
    if (props.menuOpen.open) {
      gsap.to(barOneRef.current, {
        transform: "rotate(45deg) translateY(10px)",
        marginLeft: "6px",
        duration: 0.2,
      });
      gsap.to(barTwoRef.current, {
        opacity: "0",
        duration: 0.2,
      });
      gsap.to(barThreeRef.current, {
        transform: "rotate(-45deg) translateY(-12px)",
        marginLeft: "7px",
        duration: 0.2,
      });
    } else {
      gsap.to(barOneRef.current, {
        transform: "rotate(0deg) translateY(0)",
        marginLeft: "0",
        duration: 0.2,
      });
      gsap.to(barTwoRef.current, {
        opacity: "1",
        duration: 0.2,
      });
      gsap.to(barThreeRef.current, {
        transform: "rotate(0deg) translateY(0)",
        marginLeft: "0",
        duration: 0.2,
      });
    }
  });

  return (
    <button
      name="Menu"
      onClick={props.clicked}
      className={classes.MenuButton}
      style={props.menuOpen.open ? { background: "#6A0000" } : null}
    >
      <div className={classes.Bars}>
        <div ref={barOneRef} className={classes.Bar}></div>
        <div ref={barTwoRef} className={classes.Bar}></div>
        <div ref={barThreeRef} className={classes.Bar}></div>
      </div>
      <p>Menu</p>
    </button>
  );
};

export default MenuButton;
